import React from 'react';
import { UserIcon } from 'lucide-react';
interface ChatMessageProps {
  message: string;
  isUser: boolean;
  timestamp: string;
}
export function ChatMessage({
  message,
  isUser,
  timestamp
}: ChatMessageProps) {
  return <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`} data-id="element-15">
      <div className={`flex max-w-[80%] ${isUser ? 'flex-row-reverse' : 'flex-row'}`} data-id="element-16">
        <div className={`h-8 w-8 rounded-full flex items-center justify-center text-white flex-shrink-0 ${isUser ? 'ml-2 bg-blue-600' : 'mr-2 bg-gray-700'}`} data-id="element-17">
          <UserIcon size={16} data-id="element-18" />
        </div>
        <div data-id="element-19">
          <div className={`p-3 rounded-lg ${isUser ? 'bg-blue-600 text-white rounded-tr-none' : 'bg-[#121212] text-gray-200 rounded-tl-none'}`} data-id="element-20">
            <p className="text-sm whitespace-pre-wrap" data-id="element-21">{message}</p>
          </div>
          <div className={`text-xs text-gray-500 mt-1 ${isUser ? 'text-right' : 'text-left'}`} data-id="element-22">
            {timestamp}
          </div>
        </div>
      </div>
    </div>;
}